import * as config from '../config';
import axios from 'axios';
export const request = async (method: string, url: string, data: any = {}): Promise<any> => {

  let headerObj: any = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  if (method === 'upload') {
    headerObj['Content-Type'] = 'multipart/form-data';
  }
  const token = await localStorage.getItem('token');
  if (token) {
    headerObj['authorization'] = 'Bearer ' + token;
  }

  let instance = axios.create({
    baseURL: config.baseUrl,
    timeout: 8000,
    headers: headerObj,
    validateStatus: function (status: any) {
      if (status === 401) {
        logout()
      }
      return status === 200;
    },
  });

  let base;

  // 'Authorization':this.getAuthToken()


  if (method === 'post') {
    console.log('post');
    base = instance.post(url, data);
  }
  else if (method === 'put') {
    base = instance.put(url, data);
  }
  else if (method === 'patch') {
    base = instance.patch(url, data);
  }
  else if (method === 'delete') {
    base = instance.delete(url);
  }
  // else if (method === 'upload') {
  //   base = RNFetchBlob.fetch('POST', config.baseUrl + url, headerObj, [
  //     {
  //       name: 'file',
  //       filename: data['fileName'],
  //       "type": data['type'],
  //       data: RNFetchBlob.wrap(data['uri'])
  //     }])
  // }
  else
    base = instance.get(url, { params: data });

  return base;
}
function logout() {

  // store.dispatch(logoutSuccess())

}


